import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {DeliveryMonitoringResponse, StatusType, Provider} from './types';

const {get} = requestWrapper;

const requests = {
	getCount: (
		startDate: string,
		endDate: string,
		statusType: StatusType,
		entityType?: string,
		entityId?: number,
	) =>
		get<{error: number; success: number}>(endpoints.count, {
			params: {
				startDate,
				endDate,
				statusType,
				entityType,
				entityId,
			},
		}),
	getProviders: () => get<Provider[]>(endpoints.providers),
	getList: (
		startDate: string,
		endDate: string,
		entityType?: string,
		entityId?: number,
	) =>
		get<DeliveryMonitoringResponse>(endpoints.list, {
			params: {
				startDate,
				endDate,
				entityType,
				entityId,
			},
		}),
	search: (searchValue: string, entityType?: string, entityId?: number) =>
		get<DeliveryMonitoringResponse>(endpoints.search, {
			params: {
				searchType: 'upc',
				searchValue,
				entityType,
				entityId,
			},
		}),
};

export default requests;
